import { render, staticRenderFns } from "./CadastroPreparoSPR.vue?vue&type=template&id=4d1dc374&"
import script from "./CadastroPreparoSPR.vue?vue&type=script&lang=js&"
export * from "./CadastroPreparoSPR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports